(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["belt-recommendation-quiz"] && !Shopify.designMode) return;
  try {
    (() => {
    const quizRoots = document.querySelectorAll('[data-belt-quiz]');

    if (!quizRoots.length) {
      return;
    }

    const escapeHtml = (value) => {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    };

    const getProfileKey = (answers) => {
      if (answers.goal === 'compete') {
        return 'compete';
      }

      if (answers.training === 'powerlifting') {
        return answers.goal === 'transformation' ? 'leverTransformation' : 'leverConfidence';
      }

      return answers.goal === 'transformation' ? 'trainingTransformation' : 'trainingConfidence';
    };

    const optionHasMeasurement = (name) => String(name || '').toLowerCase().includes('measurement');
    const optionHasThickness = (name) => String(name || '').toLowerCase().includes('thickness');

    const getOrderedOptions = (product) => {
      return [...(product.options || [])].sort((first, second) => {
        const getWeight = (optionName) => {
          if (optionHasMeasurement(optionName)) {
            return 0;
          }

          if (optionHasThickness(optionName)) {
            return 1;
          }

          return 2;
        };

        return getWeight(first.name) - getWeight(second.name);
      });
    };

    quizRoots.forEach((root) => {
      if (root.dataset.beltQuizInitialized === 'true') {
        return;
      }

      root.dataset.beltQuizInitialized = 'true';

      const configNode = root.querySelector('[data-belt-quiz-config]');
      const panel = root.querySelector('[data-belt-quiz-panel]');
      const view = root.querySelector('[data-belt-quiz-view]');
      const progressStep = root.querySelector('[data-belt-quiz-progress-step]');
      const progressTitle = root.querySelector('[data-belt-quiz-progress-title]');
      const progressBar = root.querySelector('[data-belt-quiz-progress-bar]');
      const backButton = root.querySelector('[data-belt-quiz-back]');
      const restartButton = root.querySelector('[data-belt-quiz-restart]');

      if (!configNode || !panel || !view || !progressStep || !progressTitle || !progressBar || !backButton || !restartButton) {
        return;
      }

      const config = JSON.parse(configNode.textContent);
      const state = {
        stepIndex: 0,
        answers: {}
      };

      const renderIntroPanel = () => {
        return `
          <div class="belt-recommendation-quiz__panel-view belt-recommendation-quiz__panel-view--intro" data-view="panel-intro">
            <p class="belt-recommendation-quiz__eyebrow">Anvil Strength Co</p>
            <h1 class="belt-recommendation-quiz__heading">${escapeHtml(config.labels.pageTitle)}</h1>
            <p class="belt-recommendation-quiz__copy">${escapeHtml(config.labels.introCopy)}</p>
          </div>
        `;
      };

      const composeResult = () => {
        const profile = config.profiles[getProfileKey(state.answers)];
        const isLever = profile.beltType === 'Lever Belt';
        const customTitle = profile.customTitle || `Custom ${profile.beltType}`;
        const brandedTitle = profile.brandedTitle || `Anvil ${profile.beltType}`;
        const customProductKey = profile.customProductKey || (isLever ? 'customLever' : 'customTraining');
        const brandedProductKey = profile.brandedProductKey || (isLever ? 'anvilLever' : 'anvilTraining');
        const customProduct = config.products[customProductKey];
        const baseAltItems = (profile.altItems || []).map((item) => ({ ...item }));
        const customAltItems = baseAltItems.concat((profile.customAltItems || []).map((item) => ({ ...item })));
        const brandedAltItems = baseAltItems.concat((profile.brandedAltItems || []).map((item) => ({ ...item })));
        const result = {
          heading: config.labels.resultHeading,
          title: '',
          thickness: profile.thickness,
          closure: profile.closure || '',
          body: profile.body,
          altItems: [],
          mode: '',
          productKey: ''
        };

        if (state.answers.priority === 'personalisation') {
          result.title = customTitle;
          result.closure = profile.customClosure || profile.closure;
          result.altItems = customAltItems;
          result.mode = 'custom';
          result.productKey = customProductKey;
          return result;
        }

        result.title = brandedTitle;
        result.closure = profile.brandedClosure || profile.closure;
        result.altItems = brandedAltItems;
        result.mode = 'branded';
        result.productKey = brandedProductKey;

        if (!result.altItems.some((item) => item.label === customTitle && item.url === (customProduct && customProduct.url))) {
          result.altItems.push({
            label: customTitle,
            url: customProduct && customProduct.url
              ? customProduct.url
              : (isLever ? config.urls.customBuilderLeverUrl : config.urls.customBuilderTrainingUrl)
          });
        }

        return result;
      };

      const renderQuestion = () => {
        const question = config.questions[state.stepIndex];
        const selectedValue = state.answers[question.id];

        return `
          <div class="belt-recommendation-quiz__question" data-view="question">
            <p class="belt-recommendation-quiz__question-step">${escapeHtml(config.labels.question)} ${state.stepIndex + 1}</p>
            <h2 class="belt-recommendation-quiz__question-title">${escapeHtml(question.label)}</h2>
            <div class="belt-recommendation-quiz__option-list">
              ${question.options.map((option, optionIndex) => {
                const isSelected = selectedValue === option.value ? ' is-selected' : '';

                return `
                  <button
                    type="button"
                    class="belt-recommendation-quiz__option${isSelected}"
                    data-belt-quiz-answer="${escapeHtml(option.value)}"
                  >
                    <span class="belt-recommendation-quiz__option-index">${String(optionIndex + 1).padStart(2, '0')}</span>
                    <span class="belt-recommendation-quiz__option-label">${escapeHtml(option.label)}</span>
                  </button>
                `;
              }).join('')}
            </div>
          </div>
        `;
      };

      const renderResult = (result) => {
        const answerPills = config.questions.map((question) => {
          const selected = question.options.find((option) => option.value === state.answers[question.id]);

          if (!selected) {
            return '';
          }

          return `<span class="belt-recommendation-quiz__selection-pill">${escapeHtml(selected.label)}</span>`;
        }).join('');

        const altMarkup = result.altItems.length
          ? `
            <div class="belt-recommendation-quiz__alt">
              <p class="belt-recommendation-quiz__alt-heading">${escapeHtml(config.labels.alsoAvailable)}</p>
              <ul class="belt-recommendation-quiz__alt-list">
                ${result.altItems.map((item) => {
                  if (item.url) {
                    return `<li><a class="belt-recommendation-quiz__alt-link" href="${escapeHtml(item.url)}">${escapeHtml(item.label)}</a></li>`;
                  }

                  return `<li>${escapeHtml(item.label)}</li>`;
                }).join('')}
              </ul>
            </div>
          `
          : '';

        return `
          <div class="belt-recommendation-quiz__result" data-view="result">
            <p class="belt-recommendation-quiz__result-heading">${escapeHtml(result.heading)}</p>
            <h2 class="belt-recommendation-quiz__result-title">${escapeHtml(result.title)}</h2>
            <div class="belt-recommendation-quiz__result-meta">
              <p class="belt-recommendation-quiz__result-meta-item"><strong>${escapeHtml(config.labels.beltThickness)}</strong> ${escapeHtml(result.thickness)}</p>
              <p class="belt-recommendation-quiz__result-meta-item"><strong>${escapeHtml(config.labels.closure)}</strong> ${escapeHtml(result.closure)}</p>
            </div>
            <p class="belt-recommendation-quiz__result-body">${escapeHtml(result.body)}</p>
            ${altMarkup}
            <div class="belt-recommendation-quiz__selection-wrap">
              <p class="belt-recommendation-quiz__selection-heading">${escapeHtml(config.labels.basedOn)}</p>
              <div class="belt-recommendation-quiz__selection-list">${answerPills}</div>
            </div>
          </div>
        `;
      };

      const renderProductPanel = (result) => {
        const product = config.products[result.productKey];

        if (!product) {
          return renderIntroPanel();
        }

        const mediaClass = result.mode === 'custom'
          ? 'belt-recommendation-quiz__panel-media belt-recommendation-quiz__panel-media--custom'
          : 'belt-recommendation-quiz__panel-media';
        const imageClass = result.mode === 'custom'
          ? 'belt-recommendation-quiz__panel-image belt-recommendation-quiz__panel-image--custom'
          : 'belt-recommendation-quiz__panel-image';
        const imageMarkup = product.imageUrl
          ? `<img src="${escapeHtml(product.imageUrl)}" alt="${escapeHtml(product.imageAlt || result.title)}" class="${imageClass}" loading="eager">`
          : '';

        const metaMarkup = `
          <div class="belt-recommendation-quiz__panel-meta">
            <p class="belt-recommendation-quiz__panel-meta-item"><strong>${escapeHtml(config.labels.beltThickness)}</strong> ${escapeHtml(result.thickness)}</p>
            <p class="belt-recommendation-quiz__panel-meta-item"><strong>${escapeHtml(config.labels.closure)}</strong> ${escapeHtml(result.closure)}</p>
          </div>
        `;

        if (result.mode === 'custom') {
          return `
            <div class="belt-recommendation-quiz__panel-view belt-recommendation-quiz__panel-view--product" data-view="panel-product">
              <div class="${mediaClass}">
                ${imageMarkup}
              </div>
              <div class="belt-recommendation-quiz__panel-body">
                <p class="belt-recommendation-quiz__panel-kicker">${escapeHtml(config.labels.recommendedBelt)}</p>
                <h2 class="belt-recommendation-quiz__panel-title">${escapeHtml(result.title)}</h2>
                ${metaMarkup}
                <p class="belt-recommendation-quiz__product-note">Use the customiser to choose your finish, colours, and final setup.</p>
                <a href="${escapeHtml(product.url)}" class="btn belt-recommendation-quiz__product-button">${escapeHtml(config.labels.customise)}</a>
              </div>
            </div>
          `;
        }

        const orderedOptions = getOrderedOptions(product);
        const fieldsMarkup = orderedOptions.map((option) => {
          const isMeasurement = optionHasMeasurement(option.name);
          const isThickness = optionHasThickness(option.name);
          const selectedValue = isThickness && option.values.includes(result.thickness)
            ? result.thickness
            : (!isMeasurement && option.values.length ? option.values[0] : '');

          return `
            <label class="belt-recommendation-quiz__field">
              <span class="belt-recommendation-quiz__field-label">${escapeHtml(option.name)}</span>
              <select
                class="belt-recommendation-quiz__field-select"
                data-belt-quiz-option
                data-option-name="${escapeHtml(option.name)}"
              >
                ${isMeasurement ? `<option value="">${escapeHtml(config.labels.selectMeasurement)}</option>` : ''}
                ${option.values.map((value) => {
                  const isSelected = value === selectedValue ? ' selected' : '';
                  return `<option value="${escapeHtml(value)}"${isSelected}>${escapeHtml(value)}</option>`;
                }).join('')}
              </select>
            </label>
          `;
        }).join('');

        return `
          <div class="belt-recommendation-quiz__panel-view belt-recommendation-quiz__panel-view--product" data-view="panel-product">
            <div class="${mediaClass}">
              ${imageMarkup}
            </div>
            <div class="belt-recommendation-quiz__panel-body">
              <p class="belt-recommendation-quiz__panel-kicker">${escapeHtml(config.labels.recommendedBelt)}</p>
              <h2 class="belt-recommendation-quiz__panel-title">${escapeHtml(result.title)}</h2>
              ${metaMarkup}
              <form
                method="post"
                action="${escapeHtml(config.urls.cartAddUrl)}"
                class="belt-recommendation-quiz__product-form"
                data-belt-quiz-product-form
                data-product-key="${escapeHtml(result.productKey)}"
              >
                <input type="hidden" name="id" value="" data-belt-quiz-variant-input>
                <input type="hidden" name="quantity" value="1">
                ${fieldsMarkup}
                <p class="belt-recommendation-quiz__product-status" data-belt-quiz-product-status>${escapeHtml(config.labels.chooseMeasurementMessage)}</p>
                <button type="submit" class="btn belt-recommendation-quiz__product-button" data-belt-quiz-add disabled>${escapeHtml(config.labels.addToCart)}</button>
              </form>
            </div>
          </div>
        `;
      };

      const updateProgress = () => {
        const totalSteps = config.questions.length;
        const visibleStep = state.stepIndex >= totalSteps ? totalSteps : state.stepIndex + 1;
        const answeredSteps = state.stepIndex > totalSteps ? totalSteps : state.stepIndex;
        const progressValue = Math.round((answeredSteps / totalSteps) * 100);

        progressStep.textContent = `${config.labels.step} ${visibleStep} ${config.labels.of} ${totalSteps}`;
        progressTitle.textContent = state.stepIndex >= totalSteps
          ? config.labels.resultReady
          : 'Three quick answers. One clear recommendation.';
        progressBar.style.width = `${progressValue}%`;
      };

      const updateButtons = () => {
        const hasHistory = state.stepIndex > 0 || Object.keys(state.answers).length === config.questions.length;

        backButton.hidden = state.stepIndex === 0;
        restartButton.hidden = !hasHistory;
      };

      const bindQuestionEvents = () => {
        view.querySelectorAll('[data-belt-quiz-answer]').forEach((button) => {
          button.addEventListener('click', () => {
            const question = config.questions[state.stepIndex];

            state.answers[question.id] = button.getAttribute('data-belt-quiz-answer');
            state.stepIndex += 1;
            render();
          });
        });
      };

      const bindProductForms = (scope) => {
        scope.querySelectorAll('[data-belt-quiz-product-form]').forEach((form) => {
          if (form.dataset.beltQuizBound === 'true') {
            return;
          }

          form.dataset.beltQuizBound = 'true';

          const productKey = form.getAttribute('data-product-key');
          const product = config.products[productKey];
          const selects = [...form.querySelectorAll('[data-belt-quiz-option]')];
          const status = form.querySelector('[data-belt-quiz-product-status]');
          const variantInput = form.querySelector('[data-belt-quiz-variant-input]');
          const addButton = form.querySelector('[data-belt-quiz-add]');

          if (!product || !selects.length || !status || !variantInput || !addButton) {
            return;
          }

          const syncVariant = () => {
            const selectedOptions = {};
            let hasMissingValue = false;

            selects.forEach((select) => {
              const optionName = select.getAttribute('data-option-name');

              if (!select.value) {
                hasMissingValue = true;
                return;
              }

              selectedOptions[optionName] = select.value;
            });

            if (hasMissingValue) {
              variantInput.value = '';
              addButton.disabled = true;
              status.hidden = false;
              status.textContent = config.labels.chooseMeasurementMessage;
              return;
            }

            const matchingVariant = (product.variants || []).find((variant) => {
              return (product.options || []).every((option) => {
                return variant.options[option.name] === selectedOptions[option.name];
              });
            });

            if (matchingVariant && matchingVariant.available) {
              variantInput.value = matchingVariant.id;
              addButton.disabled = false;
              status.hidden = true;
              status.textContent = '';
              return;
            }

            variantInput.value = '';
            addButton.disabled = true;
            status.hidden = false;
            status.textContent = config.labels.unavailableMessage;
          };

          selects.forEach((select) => {
            select.addEventListener('change', syncVariant);
          });

          syncVariant();
        });
      };

      const render = () => {
        const hasResult = state.stepIndex >= config.questions.length;
        const result = hasResult ? composeResult() : null;

        panel.setAttribute('data-panel-state', result ? 'product' : 'intro');
        panel.innerHTML = result ? renderProductPanel(result) : renderIntroPanel();
        view.innerHTML = result ? renderResult(result) : renderQuestion();

        updateProgress();
        updateButtons();
        bindProductForms(root);

        if (!result) {
          bindQuestionEvents();
        }
      };

      backButton.addEventListener('click', () => {
        if (state.stepIndex > 0) {
          if (state.stepIndex >= config.questions.length) {
            state.stepIndex = config.questions.length - 1;
          } else {
            state.stepIndex -= 1;
          }

          render();
        }
      });

      restartButton.addEventListener('click', () => {
        state.stepIndex = 0;
        state.answers = {};
        render();
      });

      render();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
